export function writtenEpisodeCount(project) {
  const value = project?.written_episode_count ?? project?.episode_count ?? 0;
  const count = Number(value);
  return Number.isFinite(count) && count > 0 ? count : 0;
}
